export default {
  name: 'ShareUserAgreement'
};